import './tripsList.css';
import {NavLink} from "react-router-dom";
import {format} from "date-fns";
import Placeholder from "../../../../shared/placeholder/placeholder";

const TripsList = ({data, classes, tripsLoader = false}) => {
    const trips = data ? data : [];
    return (
        <div className={`data-table trips-list-table font-15 ${classes}`}>
            {!tripsLoader && <ul className="table-row sf-medium table-header light-back border-radius-8">
                <li className={'from'}>From</li>
                <li className={'to'}>To</li>
                <li className={'tripId'}>Trip ID</li>
                <li className={'number-plate'}>Vehicle</li>
                <li className={'date-time'}>Date & Time</li>
                <li className={'distance'}>Distance</li>
                <li className={'duration'}>Duration</li>
                {/*<li className={'fuel-consumed'}>Fuel Consumed</li>*/}
                <li className={'alerts'}>Alerts</li>
                <li className={'score'}>Score</li>
            </ul>
            }
            {!tripsLoader &&
                trips.map((trip) =>
                    <ul key={trip._id} className="table-row padding-tb-10 sf-medium border-bottom">
                        <li className={'from'}>
                            <div className="">
                                <NavLink to={`${trip._id}`} className="highlight-color ">
                                    {trip.decodedStartLocation &&
                                        <div className="text-ellipsis">{trip.decodedStartLocation}</div>
                                    }
                                    {!trip.decodedStartLocation &&
                                        <div className="">NA</div>
                                    }
                                </NavLink>
                                {trip.decodedStartLocation &&
                                    <div className="tooltip width-200">{trip.decodedStartLocation}</div>
                                }
                            </div>

                        </li>
                        <li className={'to'}>
                            <div className="">
                                <NavLink to={`${trip._id}`} className="highlight-color ">
                                    {trip.decodedEndLocation &&
                                        <div className="text-ellipsis">{trip.decodedEndLocation}</div>
                                    }
                                    {!trip.decodedEndLocation &&
                                        <div className="">NA</div>
                                    }
                                </NavLink>
                                {trip.decodedEndLocation &&
                                    <div className="tooltip width-200">{trip.decodedEndLocation}</div>
                                }
                            </div>
                        </li>

                        <li className={'tripId'}>
                            <div className="text-ellipsis">{trip._id}</div>
                        </li>
                        <li className={'number-plate'}>{trip.vehicle.plateNo}</li>
                        <li className={'date-time'}>
                            {format(new Date(`${trip.startDate} ${trip.startTime}`), 'MMM dd, hh:mm')}
                            <span> - </span>
                            {format(new Date(`${trip.endDate} ${trip.endTime}`), 'MMM dd, hh:mm')}
                        </li>
                        <li className={'distance'}>{(trip.distance.value / 1000).toFixed(1)} Kms</li>
                        <li className={'duration'}>{(trip.duration.value / (1000 * 60 * 60)).toFixed(1)} Hrs</li>
                        {/*<li className={'fuel-consumed'}>80 Ltrs</li>*/}
                        <li className={'alerts'}>
                            {trip?.casAlerts + trip?.fmsAlerts + trip?.dmsAlerts}
                        </li>
                        {/*<li className={'date-time'}>Aug 28  9:36 - Aug 29 13:05</li>*/}
                        <li className={'date-time flex'}>
                            <div className="progress-bar item-height-6 width-60">
                                <div className="completed"></div>
                            </div>
                            <div className="margin-l-10">{Math.round((Math.random() * (100 - 80) + 80))}</div>
                        </li>
                    </ul>
                )
            }
            {tripsLoader &&
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) =>
                    <div key={index} className={'margin-t-15 round-corner-8'}>
                        <Placeholder height={'50px'}/>
                    </div>
                )
            }
        </div>
    )
}

export default TripsList;
